import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { compose } from 'recompose';
import { alignedQuestion, checkableOptionTypes } from '@nextiva/engagement-ui';
import { debouncedReduxForm, layoutMap } from 'sharedParts';

import { personalLabelTypeList } from 'sharedParts/config/personalLabelMap';
import CommentsField from 'components/CommentsField';
import isQuestionCommentsDisabled from 'utils/isQuestionCommentsDisabled';
import withTakerValidator from '../hoc/withTakerValidator';
import CheckableOptionGroupField from '../CheckableOptionGroupField';
import withNewKeyOnLocalFontChange from '../../../domains/styling/hocs/withNewKeyOnLocalFontChange';
import propTypeBlockStyling from '../../../domains/styling/config/editorBlock/PropTypes/blockStyling';

import styles from './CheckableQuestionForm.scss';
import StylingTextOptionToRTEProps from '../../../domains/styling/hocs/StylingToRTEProps/StylingTextOptionToRTEProps';

class CheckableQuestionForm extends Component {
  static propTypes = {
    block: PropTypes.shape({
      required: PropTypes.bool,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          content: PropTypes.object, // rich text @sinslav
          value: PropTypes.string, // plain text @sinslav
          id: PropTypes.string.isRequired,
        }),
      ),
      personalLabelType: PropTypes.oneOf(personalLabelTypeList),
      layout: PropTypes.oneOf(Object.keys(layoutMap)),
    }).isRequired,
    readOnly: PropTypes.bool,
    fieldParse: PropTypes.func,
    fieldFormat: PropTypes.func,
    flushSubmit: PropTypes.func.isRequired,
    validator: PropTypes.arrayOf(PropTypes.func),
    type: PropTypes.oneOf(Object.keys(checkableOptionTypes)),
    defaultFontSize: PropTypes.number,
    defaultFont: PropTypes.string,
    defaultFontColor: PropTypes.string,
    defaultBold: PropTypes.bool,
    defaultItalic: PropTypes.bool,
    defaultUnderline: PropTypes.bool,
    renderKey: PropTypes.string.isRequired,
    styling: propTypeBlockStyling,
    cancelSubmit: PropTypes.func.isRequired,
  };

  componentWillUnmount() {
    this.props.cancelSubmit();
  }

  hasLabel = option => !!option.value.trim();

  render() {
    const {
      block: { options, layout, commentsEnabled, commentsLabel },
      validator,
      readOnly,
      flushSubmit,
      fieldFormat,
      fieldParse,
      type,
      defaultFontSize,
      defaultFont,
      defaultFontColor,
      renderKey,
      styling: { selectionColor },
      styling,
      defaultBold,
      defaultItalic,
      defaultUnderline,
    } = this.props;

    return (
      <div>
        <Field
          key={renderKey} // TODO #001 Remove renderKey by updating RTE  @sinslav
          name="value"
          component={CheckableOptionGroupField}
          format={fieldFormat}
          parse={fieldParse}
          validate={validator}
          props={{
            checkedColor: selectionColor,
            type,
            optionListLayout: layout,
            options: options.filter(this.hasLabel),
            defaultFontSize,
            defaultFont,
            defaultFontColor,
            defaultBold,
            defaultItalic,
            defaultUnderline,
          }}
        />
        <Field
          name="comments"
          component={CommentsField}
          onBlur={flushSubmit}
          props={{
            readOnly,
            className: styles.comments,
            disabled: isQuestionCommentsDisabled(this.props),
            commentsEnabled,
            commentsLabel,
            styling,
          }}
        />
      </div>
    );
  }
}

export default compose(
  alignedQuestion,
  debouncedReduxForm({
    form: 'CheckableQuestionForm',
    isAutoSubmit: true,
  }),
  withTakerValidator,
  StylingTextOptionToRTEProps,
  withNewKeyOnLocalFontChange,
)(CheckableQuestionForm);
